module.exports = __webpack_public_path__ + "../resources/graphql/schema.all.min-18dc2314e22139828a9242e0645d4964.graphql";